import React, { MouseEventHandler } from 'react';
import styled from 'styled-components';

export interface ExternalLinkProps {
  sameTab?: boolean;
  href?: string;
  to?: string;
  onClick?: MouseEventHandler<HTMLElement>;
}

export const ExternalLink: React.FunctionComponent<ExternalLinkProps> = ({
  sameTab,
  to,
  href,
  onClick,
  ...rest
}) => {
  let hrefValue = href;
  if (to) {
    hrefValue = to;
  }

  return (
    <StyledExternalLink
      href={hrefValue}
      target={sameTab ? '_self' : '_blank'}
      rel="noopener noreferrer"
      onClick={onClick}
      {...rest}
    />
  );
};

const StyledExternalLink = styled.a`
  display: inline;
  :hover {
    color: ${(props): string => props.theme.colors.selected};
  }
`;



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/external-link.component.tsx